import EfFooterTc from '@elem/ui/ef-footer-tc';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const itemsJp = [
        {
            isHeader: true,
            title: '新製品発売キャンペーンに関する規約',
        },
        {
            title: '1.新製品発売記念キャンペーン期間は、2024年8月18日（日）から8月31日（土）までです。\n会員限定先行販売は2024年8月22日（木）11:00から8月31日（土）23:59までです。',
        },
        {
            title: '2.販売の台数には一部限りがあり、なくなり次第終了となりますので、ご了承ください。',
        },
        {
            title: '3.本ウェブサイトでご注文される場合、発送地域は日本のご住所のみの対応となります。',
        },
        {
            title: '4.製品を安全に配送するため、DELTA 3 Plus、ソーラーパネル、アクセサリーおよびプレゼントは別々の梱包で発送いたします。ご了承ください。',
        },
        {
            className: 'text-indent',
            title: (
                <>
                    5. DELTA 3 Plusおよび関連セットの購入プレゼントについて
                    <br />
                    1）DELTA 3 Plusおよび関連セットの購入プレゼントは９月上旬より発送いたします。
                    <br />
                    2）購入プレゼントの変更や交換などをお受けしかねます。もしかして注文をキャンセルまたは返品する場合、購入プレゼントもキャンセルまたは返品してください。購入プレゼントの詳細は
                    <a href="https://jp.ecoflow.com/pages/bousai-campaign-2024" target="blank">
                        こちら
                    </a>
                    です。
                    <br />
                    3）購入プレゼントは100個限定、なくなり次第終了となりますので、ご了承ください。
                </>
            ),
        },
        {
            title: (
                <>
                    6.ご不明点がありましたら、弊社アフターサービス<a href="mailto:hello.jp@ecoflow.com">hello.jp@ecoflow.com</a>までお問い合わせください。
                </>
            ),
        },
        {
            title: (
                <>
                    7.注文後、商品が発送されていない場合に限り、ご注文のキャンセルおよび返金を申請することができます。お客様のご都合により、購入商品到着後30日以内に返品される場合、初回取引手数料と送料をご請求させていただきますので、ご了承ください。
                    <a href="https://jp.ecoflow.com/pages/online-store-policy" target="blank">
                        返品・返金について
                    </a>
                    詳しくはこちらをご覧ください。
                </>
            ),
        },
        {
            title: (
                <>
                    8. 本ページで表示されているEcoFlow RAPID Magnetic Power
                    Bankの画像は製品開発中のイメージ図です。最適な性能と品質を確保するため、最終的な製品の外観が変更される可能性があります。
                </>
            ),
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfFooterTc list={itemsJp} />
        </div>
    );
}
